export default "__VITE_ASSET__6a3b15d4__"